import type { FC, ReactNode } from 'react';
import { ButtonGroup, Card, MatchMedia } from '@george-labs.com/design-system';

import { useGlobalColorVariants } from '@shared/core-ui-layout';
import { ActiveCustomizationFeatureProvider } from '@shared/products-core';

import { ProductAlias } from './ProductAlias';
import { ProductSubtitle } from './ProductSubtitle';

type Props = {
    alias: string;
    subtitle?: string;
    'data-cy': string;
    actions: ReactNode[];
    avatar: ReactNode;
    hasInteractableAvatar?: boolean;
};

export const PersonalizationCard: FC<Props> = ({
    alias,
    'data-cy': dataCy,
    actions,
    subtitle,
    avatar,
}) => {
    const { color } = useGlobalColorVariants();
    const shouldDisplaySubtitle = alias !== subtitle;

    return (
        <ActiveCustomizationFeatureProvider value={undefined}>
            <Card color={color} data-cy={dataCy} className="pl-3">
                <MatchMedia max={MatchMedia.TIER.SM}>
                    {({ isMatching }) => (
                        <div className="g-row align-items-center">
                            {isMatching && <div className="g-col-12 mt-2">{avatar}</div>}
                            <div className="g-col">
                                <ProductAlias alias={alias} data-cy={`${dataCy}-alias`} />
                                {shouldDisplaySubtitle && subtitle && (
                                    <ProductSubtitle
                                        subtitle={subtitle}
                                        data-cy={`${dataCy}-subtitle`}
                                    />
                                )}
                                {actions.length !== 0 && <ButtonGroup>{actions}</ButtonGroup>}
                            </div>
                            {!isMatching && <div className="g-col-auto mr-3">{avatar}</div>}
                        </div>
                    )}
                </MatchMedia>
            </Card>
        </ActiveCustomizationFeatureProvider>
    );
};
